import { resolveImage } from "../data/assetMap";

export default function PreviewModal({ doc, onClose }) {
  if (!doc) return null;
  const imgUrl = resolveImage(doc.prevUrl || doc.prev);
  return (
    <div className="overlay overlay--preview" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="preview-box">
        <div className="preview-box__head">
          <span className="preview-box__name">{doc.name}</span>
          <button type="button" className="preview-box__close" onClick={onClose}>
            {"×"}
          </button>
        </div>
        <div className="preview-box__img" style={{ backgroundImage: imgUrl ? `url("${imgUrl}")` : "none" }} />
      </div>
    </div>
  );
}
